// extracted by mini-css-extract-plugin
export var lg = "_33-4";
export var md = "_33-3";
export var sm = "_33-2";
export var xs = "_33-1";
export var xxs = "_33-0";